export default __webpack_public_path__ + "static/media/file-download-outline.f41f9bef.svg";